<template>
  <div id="app" :class="tenant">

    <div class="container"><div class="row"><div class="col">

      <div id="logo"><img :src="require('../assets/tenant/' + tenant + '/logo.png')"></div>

      <hello></hello>

    </div></div></div>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 mt-5">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">

                <router-view></router-view>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import Hello from '@/components/Hello'

  export default {
    name: 'public',
    components: {
      Hello
    },
    data: function () {
      return {
        tenant: ''
      }
    },
    methods: {
      switchTab (tab) {
        this.currentTab = tab
      },
      updateTenant () {
        this.tenant = this.$store.state.tenant
      }
    },
    computed: {
      authenticated () {
        return this.$store.getters.cognitoAuthenticated
      }
    },
    created () {
      this.updateTenant()
    },
    mounted () {

    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 10px;
  }

  #app h1 {
	  font-weight: bold;
	  color: #1e5798;
  }

  #app h6 {

  }

  #logo {
	  margin: 0 0 45px;
  }

  #logo img {
    width: 100%;
    height: auto;
  }

  .smart #logo img {
    max-width: 300px;
  }

  .msb #logo img {
    max-width: 760px;
  }


  .nav-tabs {
    margin-bottom: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/containers/Public.vue?a449a126